import { createContext, useContext } from 'react';
import { StateWithInactive } from './../types';

export interface SnippetReferencesFiltersState {
  selectedFilters: StateWithInactive;
  handleFilterChange: (filters: StateWithInactive) => void;
  resetFilter: () => void;
}

export const SnippetReferencesFiltersContext = createContext<SnippetReferencesFiltersState>({
  selectedFilters: [],
  handleFilterChange: () => undefined,
  resetFilter: () => undefined,
});

export const useSnippetReferencesFilter = () => useContext(SnippetReferencesFiltersContext);
